<script context="module">
  const ip_address_prefix = "https://dashboards-staging.smaxtec.com";

  export function get_ip_address_prefix() {
    return ip_address_prefix;
  }

  export function get_register_url() {
    return ip_address_prefix + "/api/token/";
  }

  export function get_register_url_refresh() {
    return ip_address_prefix + "/api/token/refresh/";
  }

  export function get_dashboard_dataframe_url() {
    return ip_address_prefix + "/api_dashboard_dataframe/";
  }
</script>
